import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

/**
 * https://hello.atlassian.net/wiki/spaces/MOCA/pages/3123207453/Project+Poster+Explicit+Field+Associations+EFA
 */
export type ExplicitFieldAssociationSettings = {
	readonly enabled: boolean;
};

export function fetchExplicitFieldAssociation(
	projectId: number,
): Promise<ExplicitFieldAssociationSettings> {
	const [expConfig] = UNSAFE_noExposureExp('efa_and_project_fields_page_for_tmp');
	if (!expConfig.get('isEnabled', false)) {
		return Promise.resolve({ enabled: false });
	}
	return fetch(`/rest/internal/latest/efa/projects/${projectId}`)
		.then((response) => {
			if (!response.ok) {
				throw new Error('Failed to load project toggle status');
			}
			return response.json();
		})
		.then(
			({ explicitFieldAssociationEnabled }): ExplicitFieldAssociationSettings => ({
				enabled: explicitFieldAssociationEnabled,
			}),
		);
}
